import React,{useEffect, useState} from 'react';
import { withRouter } from "react-router";

export const DrawerItem = (props) =>{
    return(
        <div className={`drawerItem ${props.Active? 'active' : ''}`} onClick={()=>props.onClick()}>
            <div className={`ItemHeader`}>
                <i className={`fa ${props.icon? 'fa-'+props.icon : 'fa-angle-left'}`} aria-hidden="true"></i>
                <span>
                    {props.title}
                </span>
            </div>
        </div>
    )
}


const GroupItems = ({intrance, children, icon, iconType, title, location, history}) =>{
    const [isGroupOpen, setIsGroupOpen] = useState(false);

    useEffect(()=>{
        console.log()
        if(location.pathname.lastIndexOf('/') !== 0){
            if(location.pathname.includes(intrance)){
                if(isGroupOpen === false){
                    setIsGroupOpen(true)
                }
            }else{
                if(isGroupOpen === true){
                    setIsGroupOpen(false)
                }
            }
        }else{
            if(intrance === location.pathname){
                if(isGroupOpen === false){
                    setIsGroupOpen(true)
                }
            }else{
                if(isGroupOpen === true){
                    setIsGroupOpen(false)
                }
            }
        }

    },[location])
    // UNSAFE_componentWillReceiveProps(nextProps){
    //     console.log(nextProps.intrance, 'intrance')
    //     console.log(nextProps.location, 'path')
    //     if(nextProps.intrance === nextProps.location.path){
    //         if(this.state.isGroupOpen === false)
    //         this.setState({isGroupOpen: true})
    //     }
    // }
    const handleBox = () =>{
        setIsGroupOpen(!isGroupOpen)
    }
    return(
        <div className={`drawerItem ${isGroupOpen ? 'open' : ''}`}>
            <div className={`ItemHeader`} onClick={handleBox}>
                <i className={`${iconType? iconType : 'fa'} ${icon? 'fa-'+ icon : 'fa-angle-left'}`} aria-hidden="true"></i>
                <span>
                {title}
                    {/* <i className={`leftAngle fa ${!this.state.isGroupOpen? 'fa-angle-down' : 'fa-angle-up'}`} aria-hidden="true"></i> */}
            </span>
                <i className={`leftAngle fa ${!isGroupOpen? 'fa-angle-down' : 'fa-angle-up'}`} aria-hidden="true"></i>
            </div>
            <div className="ItemBody">
                {
                    isGroupOpen ? children : null
                }
            </div>
        </div>
    )
}

export default withRouter(GroupItems);